import {configureStore} from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import prouctReducer from "./slices/productsSlice";
import cartReducer from "./slices/cartSlice";
import checkoutReducer from "./slices/checkoutSlice";
import orderReducer from "./slices/orderSlice";
import adminReducer from "./slices/adminSlice";
import adminProductReducer from "./slices/adminProductSlice";
import adminOrdersReducer from "./slices/adminOrderSlice";
import adminReturnReducer from "./slices/adminReturnSlice";
import offerReducer from "./slices/offerSlice";
import adminOfferReducer from "./slices/adminOfferSlice";



const store = configureStore({
    reducer: {
        auth: authReducer,
        products: prouctReducer,
        cart: cartReducer,
        checkout: checkoutReducer,
        orders: orderReducer,
        admin: adminReducer,
        adminProducts: adminProductReducer,
        adminOrders: adminOrdersReducer,
        adminReturns: adminReturnReducer,
        offer: offerReducer,
        adminOffers: adminOfferReducer,
    },

});

export default store;
